// src/store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Try to load { accessToken, refreshToken, user } from localStorage under key "user"
const saved = JSON.parse(localStorage.getItem("user"));
const initialState = saved || {
  accessToken: null,
  refreshToken: null,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /**
     * payload: { accessToken: string, refreshToken: string, user: object }
     */
    setUser(state, action) {
      const { accessToken, refreshToken, user } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.user = user;
      // persist both together under the same key "user"
      localStorage.setItem(
        "user",
        JSON.stringify({ accessToken, refreshToken, user })
      );
    },
    refreshTokenAction(state, action) {
      const { accessToken, refreshToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      // Update localStorage with new tokens
      const saved = JSON.parse(localStorage.getItem("user"));
      if (saved) {
        saved.accessToken = accessToken;
        saved.refreshToken = refreshToken;
        localStorage.setItem("user", JSON.stringify(saved));
      }
    },
    clearUser(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      localStorage.removeItem("user");
    },
  },
});

export const { setUser, refreshTokenAction, clearUser } = authSlice.actions;
export default authSlice.reducer;
